<template>
  <div class="pt-3 px-5 tasks-page-fill">
    <div class="items-center justify-between flex">
      <div class="title flex items-center">
        <h1>Dummy Tasks</h1>
      </div>
	  <div class="cardbody flex relative">
          <div ref="menuContainer" class="flex flex-row-reverse">
				<button @click="toggleMenu" class="btns flex justify-center items-center"  :class="isAddDisabled ? 'btndisabled pointer-events-none':'btnprimary'">Add</button>
					<ul  v-if="isMenuVisible" class="card shadow-sm z-50 absolute cursor-pointer top-9 w-40">
						<li class="px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center" @click="showpopupOnAddForNewTasks()">
							<div class="flex" ><img src="@/assets/edit.svg" alt="" class="mr-2"/>New Task</div>
						</li>
						<li class="px-4 py-2 cursor-pointer h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center" @click="showpopupOnAddForTemplate()">
							<div class="flex" ><img src="@/assets/templateIcon.svg" alt="" class="mr-2"/> From Template</div>
						</li>
					</ul>
			</div>
            <div class="flex flex-row-reverse items-center">
            <button class="ml-3 flex" @click="filterOpen" :class="tableRow.length == 0 ? 'filterButtonDisable pointer-events-none' : 'filterButton'">
                <img  v-if="tableRow.length == 0" src="@/assets/filterIconDisabled.svg" class="filterIcon"/>
                <img v-else src="@/assets/filterIcon.svg" class="filterIcon"/>
				Filters
            </button>
          </div>
        </div>
    </div>
	<div class="mt-3">
		<p class="headerText">
			A Planner is a tool that helps people organize and manage projects. This can include setting goals and objectives, creating schedules and budgets, assigning tasks and resourses, and tracking progress.
			A Planner is a tool that helps people organize and manage projects. This can include setting goals and objectives, creating schedules and budgets, assigning tasks and resourses, and tracking progress.
		</p>
	</div>
	<div class="tasks-table-section">
		<tableData class="flex-1 min-h-0" :tableRowData="tableRow" :headersData="headersTable" :loadData="dataLoading"></tableData>
		<div v-if="toolTipActive">
			<tool-tip :tipText="toolTipText"></tool-tip>
		</div>	
	</div>

	<popup v-if="showpopupForTasksfromNew" :popUp="showpopupForTasksfromNew">
		<div class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex">
			<div class="relative w-full max-w-xl">
				<div class="border-0 rounded relative flex flex-col w-full bg-white h-screen">
					<div class="flex items-center justify-between popupheadingcontainer rounded">
						<h1>{{ isEdit ? 'Edit Task' : 'New Task' }}</h1>
						<button class="float-right text-3xl" @click="onCancelButtonForTasks()">
							<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
						</button>
					</div>
					<div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
					<div class="impactcontainer popupbodycontainer flex-1 overflow-y-auto">
						<div class="formcontainer flex flex-col h-full">
							<div class="flex-1 overflow-auto hide-scrollbar pb-5">
								<div class="formcontainer flex flex-col">
									<div class="row flex flex-row w-full upperspacing">
										<div class="w-full">
											<label class="controllabel">Title</label>
											<input type="text" v-model.trim="newTasksObject.taskTitle" class="inputboxstyling mt-2" placeholder="Title Name" :class="{'is-invalid': v$.newTasksObject.taskTitle.$error}">
											<div v-if="v$.newTasksObject.taskTitle.$error" class="text-red-500">
											<div class="error-text" v-if="v$.newTasksObject.taskTitle.required.$invalid">Required</div>
											</div>
										</div>
									</div>
								<div class="row flex flex-row w-full upperspacing">
									<div class="w-full">
									<label class="controllabel">Description</label>
									<textarea class="inputboxstyling  mt-2" v-model.trim="newTasksObject.description" placeholder="Description" :class="{'is-invalid': v$.newTasksObject.description.$error}"></textarea>
									<div v-if="v$.newTasksObject.description.$error" class="text-red-500">
										<div class="error-text" v-if="v$.newTasksObject.description.required.$invalid">Required</div>
									</div>
									</div>
									</div>
								</div>
								<div class="row flex flex-row w-full upperspacing">
								<div class="w-1/2">
								<label class="controllabel">Start Date</label>
								<input
									type="date"
									v-model="newTasksObject.startDate"
									class="mt-2"
									@focus="openCalendar"
									:min="today"
									onkeydown="return false"
									placeholder="Select Date"
									:class="{'is-invalid': v$.newTasksObject.startDate.$error,'inputboxstylingForSelectAtPopup': newTasksObject.startDate === '','stylingForInputboxstylingForSelectAtPopup': newTasksObject.startDate !== ''}"
								/>
								<div v-if="v$.newTasksObject.startDate.$error" class="text-red-500">
									<div class="error-text" v-if="v$.newTasksObject.startDate.required.$invalid">Required</div>
								</div>
								</div>
								<div class="w-1/2 leftspacing">
								<label class="controllabel">Due Date</label>
								
								<input
									type="date"
									v-model="newTasksObject.dueDate"
									class="mt-2"
									@focus="openCalendar"
									:min="newTasksObject.startDate"
									onkeydown="return false"
									:disabled="newTasksObject.startDate === '' ? true : false"
									placeholder="Select Date"
									:class="{'is-invalid': v$.newTasksObject.dueDate.$error,'inputboxstylingForSelectAtPopup': newTasksObject.dueDate === '','stylingForInputboxstylingForSelectAtPopup': newTasksObject.dueDate !== ''}"
								/>
								<div v-if="v$.newTasksObject.dueDate.$error" class="text-red-500">
									<div class="error-text" v-if="v$.newTasksObject.dueDate.required.$invalid">Required</div>
								</div>
								</div>
								</div>
								<div class="row flex flex-row w-full upperspacing">
									<div class="w-6/12">
										<label class="controllabel">System/Activity</label>
										<div class="mt-2">
										<!-- <select
											class="inputboxstyling mt-2"
											v-model="newTasksObject.controlLevel"
											@change="controlLevelOptions(newTasksObject.controlLevel)"
											:class="{
												'is-invalid': v$.newTasksObject.controlLevel.$error
											}"
										>
											<option value="" selected disabled hidden>Please select</option>
												<option v-for="option in globalOptions" :key="option.id" :value="option.id">{{option.data }}
											</option>
										</select> -->
										<Select 
											v-model="newTasksObject.controlLevel" 
											:options="globalOptions" 
											optionLabel="data" 
											appendTo="self"
											optionValue="id" 
											placeholder="Please select" 
											class="inputboxstyling mt-2" 
											@change="controlLevelOptions(newTasksObject.controlLevel)"
										/>
										<!-- <div v-if="v$.newTasksObject.controlLevel.$error" class="text-red-500">
											<div class="error-text" v-if="v$.newTasksObject.controlLevel.required.$invalid">Required</div>
										</div> -->
									</div>
									</div>
									<div class="w-6/12 leftspacing">
										<label class="controllabel" v-if="newTasksObject.controlLevel==10107">Activity</label>
										<label class="controllabel" v-if="newTasksObject.controlLevel==10108">System</label>
										<label class="controllabel" v-if="newTasksObject.controlLevel==''">System/Activity</label>
										<div class="mt-2">
											<!-- <multiselect v-if="newTasksObject.controlLevel!=20006"
												v-model="newTasksObject.system"
												:options="systemOptions"
												:showNoOptions="false"
												@select="selectedOptions"
												@search-change="asyncSystemFind"
												:limit-text="limitText"
												:multiple="false"
												:hide-selected="true"
												:close-on-select="true"
												:clear-on-select="true"
												:disabled="newTasksObject.controlLevel==''"
												open-direction="bottom"
												label="label"
												track-by="value"    
												:searchable="true"
												:hideArrow="false"
												placeholder="System"
												class="custom-multiselect userSelect"
												:class="{
													'is-invalidmultiselect': v$.newTasksObject.system.$error,
													'has-options': systemOptions && systemOptions.length > 0,
													'no-options': !systemOptions.length &&  searchValue !== ''
												}"
											>
												<template v-slot:noResult>
													<span>No System Found</span>
												</template>
											</multiselect>-->


											<AutoComplete 
													v-if="newTasksObject.controlLevel!=10107"
													v-model="newTasksObject.system"
													:suggestions="systemOptions"
													@complete="asyncSystemFind"
													@item-select="selectedOptions"
													:disabled="newTasksObject.controlLevel==''"
													optionLabel="label"
													appendTo="body"
													optionValue="value"
													placeholder="System"
													:forceSelection="true"
													class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
													:class="{
															'p-invalid': v$.newTasksObject.system.$error,
															'has-options': systemOptions && systemOptions.length > 0,
															'no-options': !systemOptions.length &&  searchValue !== ''   
														}"
													>
													<template noResult>
													<span>No System Found</span>
												</template>
											</AutoComplete>
													<!--
											<multiselect v-if="newTasksObject.controlLevel==20006"
												v-model="newTasksObject.system"
												:options="activityOptions"
												@select="selectedOptions"
												:showNoOptions="false"
												@search-change="asyncActivityFind"
												:limit-text="limitText"
												:multiple="false"
												:disabled="newTasksObject.controlLevel?.value==''"
												:hide-selected="true"
												:close-on-select="true"
												:clear-on-select="true"
												open-direction="bottom"
												label="label"
												track-by="value"    
												:searchable="true"
												:hideArrow="false"
												placeholder="Activity"
												class="custom-multiselect userSelect"
												:class="{
													'is-invalidmultiselect': v$.newTasksObject.system.$error,
													'has-options': activityOptions && activityOptions.length > 0,
													'no-options': !activityOptions.length &&  searchValue !== ''
												}"
											>
												<template v-slot:noResult>
													<span>No Activity Found</span>
												</template>
											</multiselect> -->
													<AutoComplete 
													v-if="newTasksObject.controlLevel==10107"
													v-model="newTasksObject.system"
													:suggestions="activityOptions"
													@complete="asyncActivityFind"
													@item-select="selectedOptions"
													:disabled="newTasksObject.controlLevel?.value==''"
													optionLabel="label"
													optionValue="value"
													appendTo="body"
													:forceSelection="true"
													placeholder="Activity"
													class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
													:class="{
															'p-invalid':v$.newTasksObject.system.$error,
															'has-options': activityOptions && activityOptions.length > 0,
															'no-options': !activityOptions.length &&  searchValue !== ''   
														}"
													/>

											<div v-if="v$.newTasksObject.system.$error" class="text-red-500">
											<div class="error-text" v-if="v$.newTasksObject.system.required.$invalid">Required</div>
											</div>

										</div>
									</div>
								</div>
								<div class=" upperspacing gap-4">
								<div class="w-full">
								<label class="controllabel">Control</label>
								<div class="mt-2">
									<!-- <multiselect
										v-model="newTasksObject.controlNumber"
										:options="controlOptions"
										:showNoOptions="false"
										:disabled="newTasksObject.system==''"
										@search-change="asyncFind2"
										:limit-text="limitText"
										:multiple="false"
										:hide-selected="true"
										:close-on-select="true"
										:clear-on-select="true"
										open-direction="bottom"
										label="label"
										track-by="value"    
										:searchable="true"
										:hideArrow="false"
										placeholder="Control"
										class="custom-multiselect userSelect"
										:class="{
											'is-invalidmultiselect': v$.newTasksObject.controlNumber.$error,
											'has-options': controlOptions && controlOptions.length > 0,
											'no-options': !controlOptions.length &&  searchValue !== '',
										}"
									>
											<template v-slot:noResult>
												<span>No Control Found</span>
											</template>
										</multiselect> -->
									<AutoComplete 
										v-model="newTasksObject.controlNumber"
										:suggestions="controlOptions"
										:disabled="newTasksObject.system==''"
										@complete="asyncFind2"
										@item-select="onControlSelected"
										optionLabel="label"
										optionValue="value"
										placeholder="Control"
										appendTo="body"
										class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
										:class="{
												'p-invalid': v$.newTasksObject.controlNumber.$error,
												'has-options': controlOptions && controlOptions.length > 0,
												'no-options': !controlOptions.length &&  searchValue !== '',
											}"
										>
										<template noResult>
											<span>No Control Found</span>
										</template>
									</AutoComplete>
								</div>
								<div v-if="v$.newTasksObject.controlNumber.$error" class="text-red-500">
									<div class="error-text" v-if="v$.newTasksObject.controlNumber.required.$invalid">Required</div>
								</div>
								</div>
								</div>
								<div class="w-6/12 mt-3 mb-4">
										<label class="controllabel">Assigned To</label>
										<div>
										<!-- <multiselect
											v-model="newTasksObject.assignee"
											:options="userOptions"
											:showNoOptions="false"
											@search-change="asyncFind"
											:limit-text="limitText"
											:multiple="false"
											:hide-selected="true"
											:close-on-select="true"
											:clear-on-select="true"
											open-direction="bottom"
											label="label"
											track-by="value"    
											:searchable="true"
											:hideArrow="false"
											placeholder="Assigned to"
											class="custom-multiselect userSelect"
											:class="{
												'is-invalidmultiselect': v$.newTasksObject.assignee.$error,
												'has-options': userOptions && userOptions.length > 0,
												'no-options': !userOptions.length &&  searchValue !== ''
											}"
										>
											<template v-slot:noResult>
												<span>No Members Found</span>
											</template>
										</multiselect> -->
										<AutoComplete 
											:key="'assignee-' + assigneeFieldKey"
											v-model="newTasksObject.assignee"
											:suggestions="userOptions"
											:completeOnFocus="true"
											@complete="asyncFind"
											optionLabel="label"
											placeholder="Assigned to"
											appendTo="body"
											class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
											:class="{
													'p-invalid':  v$.newTasksObject.assignee.$error,
												'has-options': userOptions && userOptions.length > 0,
												'no-options': !userOptions.length &&  searchValue !== ''
												}"
											>
											<template noResult>
												<span>No Members Found</span>
											</template>
										</AutoComplete>
										<div v-if="v$.newTasksObject.assignee.$error" class="text-red-500">
										<div class="error-text" v-if="v$.newTasksObject.assignee.required.$invalid">Required</div>
										</div>
									</div>
								</div>
							</div>
							<div>
								<div class="border-b border-solid border-lightgrey"></div>
								<div class="buttonposition flex justify-end items-center pt-4">
									<button class="mr-1.5" :disabled="clickOnButton" :class="JSON.stringify(newTasksObject) !== JSON.stringify(dummyNewTasksObject) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onCancelbtnForTasks()">Reset</button>
									<button v-if="isEdit" @click="updateButtonForTasks()">Update</button>
									<button v-else :disabled="clickOnButton" :class="JSON.stringify(newTasksObject) !== JSON.stringify(dummyNewTasksObject) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="submitButtonForNewTasks()">Save</button>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>	
	</popup>
	<popup v-if="showPopUpForTemplate" :popUp="showPopUpForTemplate">
		<div class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex">
			<div class="relative w-full max-w-xl">
				<div class="border-0 rounded relative flex flex-col w-full bg-white h-screen">
					<div class="flex items-center justify-between m-4 rounded">
						<h1>{{ isEdit ? 'Edit Tasks For Templates' : 'Tasks For Templates' }}</h1>
						<button class="float-right text-3xl" @click="onCancelButtonAddPopUp()">
							<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
						</button>
					</div>
					<div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
					<div class="impactcontainer popupbodycontainer flex-1 overflow-y-auto">
						<div class="formcontainer flex flex-col h-full">
							<div class="flex-1 overflow-auto hide-scrollbar pb-3">
								<div class="formcontainer flex flex-col">
								<div class="row flex flex-row w-full upperspacing">
									<div class="w-full">
									<label class="controllabel">Template</label>
									<!-- <input type="text" class="inputboxstyling" placeholder="Select Template as Created"> -->
									<div>
									<!-- <multiselect
										v-model="tasksTemplateObject.template"
										:options="templates"
										:showNoOptions="false"
										@search-change="asyncFind1"
										:limit-text="limitText"
										:multiple="false"
										:hide-selected="true"
										:close-on-select="true"
										:clear-on-select="true"
										open-direction="bottom"
										label="label"
										track-by="value"    
										:searchable="true"
										:hideArrow="false"
										placeholder="Template name"
										class="custom-multiselect userSelect"
										:class="{
											'is-invalidmultiselect': v$.tasksTemplateObject.template.$error,
											'has-options': templates && templates.length > 0,
											'no-options': !templates.length &&  searchValue !== ''
										}"
									>
										<template v-slot:noResult>
											<span>No Templates Found</span>
										</template>
									</multiselect> -->
									<AutoComplete 
										v-model="tasksTemplateObject.template"
										:suggestions="templates"
										@complete="asyncFind1"
										optionLabel="label"
										optionValue="value"
										appendTo="self"
										placeholder="Template Name"
										class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
										:class="{
												'p-invalid': v$.tasksTemplateObject.template.$error,
												'has-options': templates && templates.length > 0,
												'no-options': !templates.length &&  searchValue !== ''
											}"
										>
										<template noResult>
											<span>No Templates Found</span>
										</template>
									</AutoComplete>
									<div v-if="v$.tasksTemplateObject.template.$error" class="text-red-500">
									<div class="error-text" v-if="v$.tasksTemplateObject.template.required.$invalid">Required</div>
									</div>
								</div>
									</div>
								</div>
								<div class="row flex flex-row w-full upperspacing">
									<div class="w-full">
									<label class="controllabel">Title</label>
									<input type="text" v-model.trim="tasksTemplateObject.templateTitle" class="inputboxstyling mt-2" placeholder="Title Name" :class="{'is-invalid': v$.tasksTemplateObject.templateTitle.$error}">
									<div v-if="v$.tasksTemplateObject.templateTitle.$error" class="text-red-500">
									<div class="error-text" v-if="v$.tasksTemplateObject.templateTitle.required.$invalid">Required</div>
									</div>
									</div>
								</div>
								<div class="row flex flex-row w-full upperspacing gap-4">
									<div class="w-1/2">
									<label class="controllabel">Start Date</label>
									<input
										type="date"
										v-model="tasksTemplateObject.startDate"
										class="mt-2"
										:min="today"
										@focus="openCalendar"
										onkeydown="return false"
										placeholder="Select Date"
										:class="{'is-invalid': v$.tasksTemplateObject.startDate.$error,'inputboxstylingForSelectAtPopup': tasksTemplateObject.startDate === '','stylingForInputboxstylingForSelectAtPopup': tasksTemplateObject.startDate !== ''}"
									/>
									<div v-if="v$.tasksTemplateObject.startDate.$error" class="text-red-500">
									<div class="error-text" v-if="v$.tasksTemplateObject.startDate.required.$invalid">Required</div>
									</div>
									</div>
									<div class="w-1/2 ml-2">
									<label class="controllabel">Due Date</label>
									<input
										type="date"
										v-model="tasksTemplateObject.dueDate"
										class="mt-2"
										:min="tasksTemplateObject.startDate"
										@focus="openCalendar"
										:disabled="tasksTemplateObject.startDate === '' ? true : false"
										onkeydown="return false"
										placeholder="Select Date"
										:class="{'is-invalid': v$.tasksTemplateObject.dueDate.$error,'inputboxstylingForSelectAtPopup': tasksTemplateObject.dueDate === '','stylingForInputboxstylingForSelectAtPopup': tasksTemplateObject.dueDate !== ''}"
									/>
									<div v-if="v$.tasksTemplateObject.dueDate.$error" class="text-red-500">
									<div class="error-text" v-if="v$.tasksTemplateObject.dueDate.required.$invalid">Required</div>
									</div>
									</div>
								</div>
								<div class="row flex flex-row w-full upperspacing">
									<div class="w-full">
									<label class="controllabel">Description</label>
									<textarea class="inputboxstyling mt-2" v-model.trim="tasksTemplateObject.description" placeholder="Description" :class="{'is-invalid': v$.tasksTemplateObject.description.$error}"></textarea>
									<div v-if="v$.tasksTemplateObject.description.$error" class="text-red-500">
									<div class="error-text" v-if="v$.tasksTemplateObject.description.required.$invalid">Required</div>
									</div>
									</div>
								</div>
								</div>
							</div>
							<div>
								<div class="border-b border-solid border-lightgrey"></div>
								<div class="buttonposition flex justify-end items-center pt-4">
									<button class="mr-1.5" :disabled="clickOnButton" :class="JSON.stringify(tasksTemplateObject) !== JSON.stringify(dummyTasksTemplateObject) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onCancelbtn()">Reset</button>
									<button v-if="isEdit" @click="updateButtonForTemplate()">Update</button>
									<button v-else :disabled="clickOnButton" :class="JSON.stringify(tasksTemplateObject) !== JSON.stringify(dummyTasksTemplateObject) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="submitButtonforTemplate()">Save</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>	
		</div>
	</popup>
  </div>
</template>
<style scoped>
.heightofplusicon{
	height:13px;
}
.tasks-page-fill {
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	overflow: hidden;
	box-sizing: border-box;
}
.tasks-table-section {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
}
</style>
<script lang="ts">
import { defineComponent } from "vue";
import { helpers, required } from "@vuelidate/validators";
import { emitter,toast } from '@/main';
import { useVuelidate } from "@vuelidate/core";
import popup from "@/components/popup.vue";
import tableData from "@/components/tableData.vue";
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import toolTip from '@/components/toolTip.vue';
import moment from "moment";
import Select from 'primevue/select';
import AutoComplete from 'primevue/autocomplete';

// import { template } from "lodash";
export default defineComponent({
  data(): any {
    return {
	  v$: useVuelidate(),
      isMenuVisible: false,
	  showPopUpForTemplate:false,
      showpopupForTasksfromNew:false,
	  selectedRowData:[],
	  allActiveControls:[],
	  allTasksList: [],
	  headersTable:["taskId","title","tier","target","team","frequency","assignee","dueDate","taskstatus"],
	  tableRow:[],
	  activeTemplates:[],
	  templateOptions:[],
	  controlOptions:[],
	  clickOnButton: false,
	  tasksTemplateObject:{
		template:'',
        templateTitle:'',
		startDate: '',
        dueDate: '',
		description:'',
	  },
	  dummyTasksTemplateObject:{
        templateTitle:'',
		startDate: '',
        dueDate: '',
		description:'',
	  },
	  newTasksObject:{
        taskTitle:'',
		startDate:'',
		dueDate:'',
		controlNumber:'',
		assignee:'',
		description:'',
		controlLevel:'',
		system:''
	  },
	  dummyNewTasksObject:{
        taskTitle:'',
		startDate:'',
		dueDate:'',
		controlNumber:'',
		assignee:'',
		description:'',
		controlLevel:'',
		system:''
	  },
	  globalOptions:[
		{
			id:10107,
			data:'Activity'
		},
		{
			id:10108,
			data:'System'
		},
		// {
		// 	id:10109,
		// 	data:'Project'
		// }
	  ],
	  optionUserArray:[],
	  lastAssigneeControlId:'',
	  selectedControlOption:null,
	  assigneeFieldKey:0,
	  optionsProjectArray:[],
	  userOptions:[],
	  templates:[],
	  keysOfActiveControls:[],
	  controlsArray:[],
	  toolTipActive:false,
	  toolTipText:'',
	  searchValue:'',
	  accessControlMapping:[],
	  controlLevelData:[],
	  allSystems:[],
	  systemOptions:[],
	  optionSystemArray:[],
	  allProcess:[],
	  teamObject:[],
	  optionsActivityArray:[],
	  activityOptions:[],
	  departmentList:[]
	};
  },
  validations() {
    return {
		tasksTemplateObject:{
			template:{required},
			templateTitle:{required},
			startDate: {required},
			dueDate: {required},
			description:{required},
		},
	  newTasksObject:{
        taskTitle:{required},
		startDate:{required},
		dueDate:{required},
		assignee:{required},
		description:{required},
		controlLevel:{required},
		system:{required},
		controlNumber:{required}
	  },
	  dataLoading:true
	}
  },
  components: {
    popup,
	tableData,
	Multiselect,
	toolTip,
	Select,
	AutoComplete
},
  methods:{
	toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
	selectedOptions(data:any){
		this.newTasksObject.controlNumber = "";
		this.clearControlAssignee();
		this.controlOptions = this.controlsArray.filter((obj:any) => {	
			if(this.newTasksObject.controlLevel==10107 && this.newTasksObject.system.value == obj.activityId){							
				return obj.activityId.toString()==data.value.toString();
			}
			if(this.newTasksObject.controlLevel==10108 && this.newTasksObject.system.value == obj.systemId){						
				return obj.systemId.toString()==data.value.toString();
			}
			else{												
				return false;
			}
		});
	},
	hasPermission(userInfo:any, appId:any, entityId:any, permissionId:any) {
		if (!userInfo || !userInfo.apps) return false;

		const app = userInfo.apps.find((a:any) => a.appId === appId);
		if (!app) return false;

		const entity = app.entities?.find((e:any) => e.entityId === entityId);
		if (!entity) return false;

		return entity.permissions?.includes(permissionId) || false;
	},
	filterOpen() {
		this.showFilters = !this.showFilters;
		if (this.showFilters == true) {
			this.dummyList = this.savedAuditSets;
		} else {
			this.savedAuditSets = this.dummyList;
		}
		emitter.emit('visible', this.showFilters);
	},
	handleClickOutside(event:any) {
      const menuContainer = this.$refs.menuContainer;
      if (menuContainer && !menuContainer.contains(event.target)) {
        this.isMenuVisible = false;
      }
    },
	showpopupOnAddForTemplate(){
		this.isEdit = false;
		this.showPopUpForTemplate = !this.showPopUpForTemplate;
		this.tasksTemplateObject = {
		templateTitle: '',
		startDate: '',
		dueDate: '',
		description: ''
	};
	},
	getTeamName(departmentId: any) {
		let team = this.teamObject.find((obj: any) => {
			return obj.value == departmentId;
		});
		if (team == undefined || team == null) {
			let empty = 'N/A';
			return empty;
		} else {
			return team.label;
		}
	},
	limitText (count:any) {
		// return `and ${count} other countries`
		// console.log('countcount',count)
	},
	asyncFind2(query:any) {
		query=query.query.trim()
		this.searchValue = query
		let condition:any;
            if (query === '') {
                this.controlOptions = [];
            } else if (query.length > 0) {
                this.controlOptions = this.controlsArray.filter((obj:any) => {
					if(this.newTasksObject.controlLevel==10107 && this.newTasksObject.system!=null && this.newTasksObject.system.value == obj.activityId){						
                    	return obj.label.toLowerCase().includes(query.toLowerCase());
					}
					if(this.newTasksObject.controlLevel==10108 && this.newTasksObject.system!=null && this.newTasksObject.system.value == obj.systemId){						
						return obj.label.toLowerCase().includes(query.toLowerCase());
					}
					else{												
						return false;
					}
                });
            }
    },
	asyncSystemFind(query:any){
		query=query.query.trim();
		this.searchValue = query
            if (query === '') {
                this.systemOptions = [];
            } else if (query.length > 0) {
                this.systemOptions = this.optionSystemArray.filter((obj:any) => {
                    return obj.label.toLowerCase().includes(query.toLowerCase())
                    // const notSelected = !this.controlIdsArray.includes(obj.value);
                    // return matchesQuery && notSelected;
                });
            }
	},
	asyncActivityFind(query:any){
		query=query.query.trim();
		this.searchValue = query
            if (query === '') {
                this.activityOptions = [];
            } else if (query.length > 0) {				
                this.activityOptions = this.optionsActivityArray.filter((obj:any) => {
                    return obj.label.toLowerCase().includes(query.toLowerCase())
                });
            }
	},
	asyncFind(query:any){
		query=(query?.query || '').trim()
		this.searchValue = query
		if(query == ''){
			this.userOptions = [...this.optionUserArray]
		}else if(query.length > 0){
			this.userOptions = this.optionUserArray.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
		}
	},
	recordId(value:any){
		if (value == null || value === '') return '';
		if (typeof value === 'string' || typeof value === 'number') return String(value);
		if (typeof value === 'object') {
			if (value.$oid) return String(value.$oid);
			if (value._id != null) return this.recordId(value._id);
			if (typeof value.toHexString === 'function') return value.toHexString();
		}
		const text = String(value);
		return text === '[object Object]' ? '' : text;
	},
	resolveControlOption(control:any){
		if (!control) return null;
		const directId = this.recordId(control.value != null ? control.value : control);
		const fromList = this.controlsArray.find((item:any) => this.recordId(item.value) === directId);
		const fromActive = (this.allActiveControls || []).find((item:any) => this.recordId(item._id) === directId);
		if (control && typeof control === 'object' && (control.controlOwner !== undefined || control.activityId || control.systemId)) {
			return {
				...control,
				controlOwner: control.controlOwner || fromList?.controlOwner || fromActive?.controlOwner || ''
			};
		}
		if (fromList) {
			return {
				...fromList,
				controlOwner: fromList.controlOwner || fromActive?.controlOwner || ''
			};
		}
		if (fromActive) {
			return {
				label: fromActive.controlTitle,
				value: fromActive._id,
				activityId: fromActive.activityId,
				systemId: fromActive.systemId,
				controlOwner: fromActive.controlOwner || ''
			};
		}
		return null;
	},
	assigneeForControl(control:any){
		const ownerId = this.recordId(control?.controlOwner);
		if (!ownerId) return '';
		return this.optionUserArray.find((user:any) => this.recordId(user.value) === ownerId) || '';
	},
	applyControlAssignee(control:any){
		this.selectedControlOption = control || null;
		this.newTasksObject.assignee = control ? this.assigneeForControl(control) : '';
		this.assigneeFieldKey += 1;
	},
	clearControlAssignee(){
		this.lastAssigneeControlId = '';
		this.selectedControlOption = null;
		this.newTasksObject.assignee = '';
		this.assigneeFieldKey += 1;
	},
	onControlSelected(event:any){
		const picked = event?.value ?? event;
		this.$nextTick(() => {
			const control = this.resolveControlOption(picked) || this.resolveControlOption(this.newTasksObject.controlNumber);
			if (!control) {
				this.clearControlAssignee();
				return;
			}
			this.lastAssigneeControlId = this.recordId(control.value);
			this.applyControlAssignee(control);
		});
	},
	controlLevelOptions(query:any){
		if(query == 20006){
			this.systemOptions=[]
			this.newTasksObject.system=""
			this.newTasksObject.controlNumber=""
			this.clearControlAssignee();
			this.activityOptions = [...this.optionsActivityArray]
		}
		else{
			this.activityOptions=[];
			this.newTasksObject.system=""
			this.newTasksObject.controlNumber=""
			this.clearControlAssignee();
			this.systemOptions =[...this.optionSystemArray]
		}
	},
	asyncFind1(query:any){
		query=query.query.trim()
		this.searchValue = query
		if(query == ''){
			this.templates = []
		}else if(query.length > 0){
			this.templates = this.templateOptions.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
		}
	},
	async showpopupOnAddForNewTasks(){
	await this.getAllBusinessProcesses();
	await this.getAllProjects();
	await this.getAllActiveUsers();
	await this.getAllActiveControls();
	await this.getActiveTemplates(20501);
	// await this.getAllTeams();
	await this.getAllSystems();
		this.isEdit = false;
        this.showpopupForTasksfromNew = !this.showpopupForTasksfromNew;
		this.userOptions = [...this.optionUserArray];
		this.lastAssigneeControlId = '';
		this.selectedControlOption = null;

		this.newTasksObject = {
			taskTitle: '',
			startDate: '',
			dueDate: '',
			controlNumber: '',
			assignee: '',
			description: '',
			controlLevel:'',
			system:''
		};
		this.dummyNewTasksObject={
			taskTitle: '',
			startDate: '',
			dueDate: '',
			controlNumber: '',
			assignee: '',
			description: '',
			controlLevel:'',
			system:''
		}
	},
	onCancelButtonAddPopUp(){
		this.showPopUpForTemplate=false;
		this.onCancelbtn();
	},
	onCancelButtonForTasks(){
        this.showpopupForTasksfromNew=false;
		this.onCancelbtnForTasks();
	},
	openCalendar(event: any) {
      event.target.showPicker();
    },
	onCancelbtn() {
	this.tasksTemplateObject = { ...this.dummyTasksTemplateObject };
	this.v$.$reset();
	},
    onCancelbtnForTasks() {
	this.lastAssigneeControlId = '';
	this.selectedControlOption = null;
	this.newTasksObject = { ...this.dummyNewTasksObject };
	this.v$.$reset();
	},
	submitButtonforTemplate(){
      this.v$.$touch();
	  if (!this.v$.tasksTemplateObject.$invalid){
		
		this.clickOnButton = true;
		let copyoftasksTemplateObject: any = {...this.tasksTemplateObject}
		this.taskFromTemplateOption(copyoftasksTemplateObject)
		this.showPopUpForTemplate=false;
		this.onCancelbtn();
	  }
	},
	submitButtonForNewTasks(){
		this.v$.$touch();
		 if (!this.v$.newTasksObject.$invalid){
			this.clickOnButton = true;
			
			let copyOfnewTaskObject: any = {...this.newTasksObject}
			this.taskFromNewOption(copyOfnewTaskObject)
			this.showpopupForTasksfromNew=false;
			this.onCancelbtnForTasks();
		 }
    },
	async taskFromTemplateOption(obj:any){
	
		let templateId:any = obj.template
		const payload: any = {
			linkedTemplateId: templateId.value,
			mainTaskName:obj.templateTitle,
			startDate: obj.startDate,
			dueDate:obj.dueDate,
			description:obj.description,
			createdBy:this.userInfo._id,
			createdAt:new Date(),
			customTemplateTask:true
		};
	
		try{
			await this.$http
				.post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_PLANNER_WORKFLOW_ID}/planner/template/task`,[payload])
				.then((result: { data: any }) => {
					toast.info('Task created from template', {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				})
				.catch((error: any) => {
					if(error.response && error.response.status==403) {
                            toast.error(`${error.response.data.error}`, {
                            timeout: 1000,
                            closeOnClick: true,
                            closeButton: 'button',
                            icon: true
                        });
                    }
					else{
						toast.error(` ${error}`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
					}
			});
				await this.getAllTasks();

		} catch(err){
			toast.error('Error', {
				timeout: 1000,
				closeOnClick: true,
				closeButton: 'button',
				icon: true
			});
		} finally {
			this.clickOnButton = false;
		}
		
	},
	async taskFromNewOption(obj: any){
		let payload:any;
		const controlOption = this.resolveControlOption(obj.controlNumber) || this.selectedControlOption || obj.controlNumber;
		const assigneeId = obj.assignee && typeof obj.assignee === 'object' ? obj.assignee.value : obj.assignee;
		const targetId = obj.system && typeof obj.system === 'object' ? obj.system.value : obj.system;
		obj.control = controlOption?.value || obj.controlNumber;
            if(controlOption && controlOption.hasOwnProperty('activityId')){
				let selectedActivity = this.optionsActivityArray.find((activity:any)=> activity.value?.toString() === targetId?.toString());
                payload = {
				TaskName: obj.taskTitle,
                startDate: obj.startDate,
                dueDate:obj.dueDate,
                assignee:assigneeId,
                description:obj.description,
                createdBy:this.userInfo._id,
				createdAt:new Date(),
                control:controlOption?.value||'',
                activityId:targetId,
				categoryType:10107,
				departments:selectedActivity?.departments || ''
                };
            }
            if(controlOption && controlOption.hasOwnProperty('systemId')){
                payload = {
				TaskName: obj.taskTitle,
                startDate: obj.startDate,
                dueDate:obj.dueDate,
                assignee:assigneeId,
                description:obj.description,
                createdBy:this.userInfo._id,
				createdAt:new Date(),
				categoryType:10108,
                control:controlOption?.value||'',
                systemId:targetId
                };
            }
		let workflowId: any = "66c2f0beb4f223dca569f907"
		try{
			await this.$http
			.post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_PLANNER_WORKFLOW_ID}/planner/subtask/task`,[payload])
			.then((result: { data: any }) => {
				toast.info("Created Task", {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			})
			.catch((error: any) => {
				if(error.response && error.response.status==403) {
					toast.error(`${error.response.data.error}`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
                }
				else{
					toast.error(` ${error}`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				}
			});
			await this.getAllTasks();
		} catch (err){
			toast.error('Error', {
				timeout: 1000,
				closeOnClick: true,
				closeButton: 'button',
				icon: true
			});
		} finally {
			this.clickOnButton = false;
		}
		
	},
	updateButtonForTemplate() {
      this.v$.$touch();
      if (!this.v$.tasksTemplateObject.$invalid && this.selectedRowData) {
        Object.assign(this.selectedRowData, {
          name: this.tasksTemplateObject.templateTitle,
          startDate: this.tasksTemplateObject.startDate,
          dueDate: this.tasksTemplateObject.dueDate,
          description: this.tasksTemplateObject.description,
		  updatedBy:this.userInfo._id,
		  updatedAt:new Date()
        });

        this.showPopUpForTemplate = false;
        this.onCancelbtn();
      }
	},
	updateButtonForTasks() {
      this.v$.$touch();
      if (!this.v$.newTasksObject.$invalid && this.selectedRowData) {
        Object.assign(this.selectedRowData, {
          name: this.newTasksObject.taskTitle,
          controlNo: this.newTasksObject.controlNumber,
          startDate: this.newTasksObject.startDate,
          dueDate: this.newTasksObject.dueDate,
          assignee: this.newTasksObject.assignee,
          description: this.newTasksObject.description,
		  updatedBy:this.userInfo._id,
		  updatedAt:new Date()
        });
        this.showpopupForTasksfromNew = false;
        this.onCancelbtnForTasks();
	  }
	},
    // onClickOnRowData(){
	// 	emitter.on('clickedOnRowData', this.handleRowClick);
	// },
	async getAllTasks() {
		this.tableRow = [];
		this.allTasksList = [];
		try{
			await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/tasks/getAll`).then((res: any) => {
				this.allTasksList = res.data
				
				this.allTasksList.forEach((task: any) => {

					let assignee: any = this.optionUserArray.find((name: any)=>{ return name.value == task.assignee})

					let TaskName:any;
					let contolObj:any;
					let controlId:any;
					let team:any;
					let target:any;
					let departmentTeam:any = this.getTeamName(task.departments);
					if(task.actionType == 20501){
						TaskName = task.mainTaskName != undefined ? task.mainTaskName : 'N/A';
						if(this.allActiveControls!=undefined){
							contolObj = this.allActiveControls.find((control:any)=>control._id == task.control);
						}
						// if(task.createdBy){
						// 	let user = this.orgUsersList.find((user:any)=>user._id.toString()==task.createdBy.toString());							
						// 	team = user?.departmentId
						// }
						else{
							contolObj='N/A'
						}
						controlId  = contolObj != undefined && contolObj.clientUniqueId != undefined ? contolObj.clientUniqueId : 'N/A'
					}else if(task.actionType == 20502){
						
						if(task.controlName!=undefined){
							contolObj = task.controlName;
						}
						// if(task.createdBy){
						// 	let user = this.orgUsersList.find((user:any)=>user._id.toString()==task.createdBy.toString());							
						// 	team = user?.departmentId
						// }
						else{
							contolObj='N/A'
						}
						TaskName = contolObj!=undefined?contolObj:'N/A';
						controlId  = task.clientUniqueId != undefined ? task.clientUniqueId : 'N/A'

					}else if(task.actionType == 20503){
						TaskName = task.TaskName != undefined ? task.TaskName : 'N/A';
						// if(task.createdBy){
						// 	let user = this.orgUsersList.find((user:any)=>user._id.toString()==task.createdBy.toString());							
						// 	team = user?.departmentId
						// }
						if(this.allActiveControls!=undefined){
							contolObj = this.allActiveControls.find((control:any)=>control._id == task.control);
						}
						else{
							contolObj='N/A'
						}
						controlId = contolObj != undefined && contolObj.clientUniqueId != undefined ? contolObj.clientUniqueId : 'N/A'
					}
					else if(task.actionType == 20504){
						TaskName = task.TaskName != undefined ? task.TaskName : 'N/A';
						//if(task.createdBy){
							//let user = this.orgUsersList.find((user:any)=>user._id.toString()==task.createdBy.toString());
							//team = user?.departmentId
						//}
						if(this.allActiveControls!=undefined){
							contolObj = this.allActiveControls.find((control:any)=>control._id == task.control);
						}
						else{
							contolObj='N/A'
						}
						controlId = contolObj != undefined && contolObj.clientUniqueId != undefined ? contolObj.clientUniqueId : 'N/A'
					}
					let date:any;
					let tier:any;
					if(task.dueDate){
						date = moment(task.dueDate).format('YYYY-MM-DD')
					}
					// if(this.userInfo && this.userInfo.organisationType==10701){						
					// 	if(task.assignee){							
					// 		let user = this.orgUsersList.find((user:any)=>user._id.toString()==task.assignee.toString());							
					// 		team = user?.departmentId

					// 	}
					// }					
					// if(task.activityId){
					// 	let activity = this.optionsActivityArray.find((activity:any)=>task.activityId.toString()== activity.value.toString());						
					// 	target = activity!=undefined?activity.label:'N/A';
					// 	let tierLevel = this.globalOptions.find((tier:any)=>tier.id==task.categoryType);
					// 	tier = tierLevel && tierLevel!=undefined?tierLevel.id:'N/A'
					// }
					// if(task.systemId){
					// 	let system = this.optionSystemArray.find((sys:any)=>task.systemId.toString()== sys.value.toString());
					// 	target = system!=undefined?system.label:'N/A';
					// 	let tierLevel = this.globalOptions.find((tier:any)=>tier.id==task.categoryType);
					// 	tier = tierLevel && tierLevel!=undefined?tierLevel.id:'N/A'
					// }
					// if(task.projectId){
					// 	let system = this.optionsProjectArray.find((sys:any)=>task.projectId.toString()== sys.value.toString());
					// 	target = system!=undefined?system.label:'N/A';
					// 	let tierLevel = this.globalOptions.find((tier:any)=>tier.id==task.categoryType);
					// 	tier = tierLevel && tierLevel!=undefined?tierLevel.id:'N/A'

					// }
                    if(task.categoryType ==10107){
                        target = task.activityName
                    }
                    if(task.categoryType ==10108){
                        target = task.systemName
                    }
                    if(task.categoryType ==10109){
                        target = task.projectName
                    }
                    
					let taskObj: any = {
						taskId: task.taskId,
						title: TaskName != undefined ? TaskName : 'N/A',
						tier:task.tierName!=undefined?task.tierName:'N/A',
						// CCID: controlId!=undefined?controlId:'N/A',
						target:target!=undefined?target:'N/A',
						actionType:task.actionType != undefined ? task.actionType : 'N/A',
						team:task.departmentName!=undefined?task.departmentName:'N/A',
						frequency:task.controlFrequency?task.controlFrequency:'',
						assignee: task.assigneeName != undefined ? task.assigneeName : 'N/A',
						dueDate: task.dueDate != undefined && task.dueDate!='' ? date : 'N/A',
						taskstatus: task.statusCode != undefined ? task.statusCode : 'N/A',
						id: task._id != undefined ? task._id : 'N/A',
						createdAt:new Date(),
						createdBy:task.createdBy
						// actionType: task.actionType != undefined ? task.actionType : 'N/A',
					}
					if(taskObj.taskstatus != 10411){
						this.tableRow.push(taskObj)
					}
					
				});	

				this.dataLoading = false;
			});
		}catch(e:any){
			this.dataLoading = false;
		}
	},
	async getAllActiveControls(){
		await this.$http
			.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls/active`)
			.then((result: { data: any }) => {
				this.allActiveControls = result.data;
			})
			.catch((error: any) => {
				toast.error(` ${error}`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			});
			for (var i = 0; i < this.allActiveControls.length; i++) {
				this.keysOfActiveControls = Object.keys(this.allActiveControls[i])
					if(this.allActiveControls[i].hasOwnProperty('activityId')){
						this.controlsArray.push({ label: this.allActiveControls[i].controlTitle, value: this.allActiveControls[i]._id,activityId:this.allActiveControls[i].activityId, controlOwner: this.allActiveControls[i].controlOwner || '' });
					}
					if(this.allActiveControls[i].hasOwnProperty('systemId')){
						this.controlsArray.push({ label: this.allActiveControls[i].controlTitle, value: this.allActiveControls[i]._id ,systemId:this.allActiveControls[i].systemId, controlOwner: this.allActiveControls[i].controlOwner || '' });
					}
				// if(this.keysOfActiveControls.includes('controlFrequency')&& this.allActiveControls[i].controlFrequency == 1){
				// }
			}
        },
	async getAllActiveUsers() {
		await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
	
			this.orgUsersList = res.data
			this.optionUserArray = []
			for (var i = 0; i < this.orgUsersList.length; i++) {
				this.optionUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
			}
			this.userOptions = [...this.optionUserArray]
		});
	},
	async getAllSystems(){
		await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20005}`).then((result: any) => {
			this.allSystems = result.data;
			// this.orgUsersList = res.data
			for (var i = 0; i < this.allSystems.length; i++) {
				this.optionSystemArray.push({ label: this.allSystems[i].systemName, value: this.allSystems[i]._id });
			}
        });
	},
	async getActiveTemplates(typeId: any){
		
		try{
			await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/type/${typeId}/templates/getAll`).then((result: any) => {
				this.activeTemplates = result.data
			});

			for (var i = 0; i < this.activeTemplates.length; i++) {
				if(this.activeTemplates[i].controls && this.activeTemplates[i].controls.length != 0){
					this.templateOptions.push({ label: this.activeTemplates[i].title, value: this.activeTemplates[i]._id });
				}
			}
		}catch(e:any){
			// console.log(e)
		}

	},
	async getAllBusinessProcesses() {
		await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`).then((result: any) => {			
			this.allProcess = result.data;
			for(let i=0;i<this.allProcess.length;i++){
				this.optionsActivityArray.push({ label: this.allProcess[i].businessProcessName, value: this.allProcess[i]._id ,departments : this.allProcess[i].department});
			}
		});	
    },
	async getAllProjects() {
		await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/projects/getAll`).then((result: any) => {			
			this.allProcess = result.data;
			for(let i=0;i<this.allProcess.length;i++){
				this.optionsProjectArray.push({ label: this.allProcess[i].projectName, value: this.allProcess[i]._id ,departments : this.allProcess[i].department});
			}
		});
    },
	handleRowClick(rowData: any) {
	this.isEdit = true;
	this.selectedRowData = rowData;
    if (rowData.id === "1") {
		this.showPopUpForTemplate = true;
		this.dummyTasksTemplateObject = {
		templateTitle: rowData.name,
		startDate: rowData.startDate,
		dueDate: rowData.dueDate,
		description: rowData.description,
		};
		this.tasksTemplateObject = { ...this.dummyTasksTemplateObject };
	} else {
		this.showpopupForTasksfromNew = true;
		this.dummyNewTasksObject = {
		taskTitle: rowData.name,
		startDate: rowData.startDate,
		dueDate: rowData.dueDate,
		controlNumber: rowData.controlNo,
		assignedTo: rowData.assigned,
		description: rowData.description,
		};
		this.newTasksObject = { ...this.dummyNewTasksObject };
	}
	},
	goToTemplateTaskEdit(id: any){		
		this.$router.push({ name: 'testTemplateTaskEdit' ,params:{ taskId : id}});
	},
	goToSubTaskEdit(id: any){
		this.$router.push({ name: 'testSubTaskEdit' ,params:{ subtaskId : id}});
	},
	async getAllTeams(){
		await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((result: any) => {
			this.departmentList = result.data
			for (var i = 0; i < this.departmentList.length; i++) {
                this.teamObject.push({ label: this.departmentList[i].displayName, value: this.departmentList[i]._id });
            }
		});

	}
   },
  watch: {
	"newTasksObject.controlNumber"(value: any) {
		if (!this.showpopupForTasksfromNew) return;
		if (value == null || value === '') {
			this.clearControlAssignee();
			return;
		}
		const control = this.resolveControlOption(value);
		if (!control || control.value == null) return;
		const controlId = this.recordId(control.value);
		if (!controlId || controlId === this.lastAssigneeControlId) return;
		this.lastAssigneeControlId = controlId;
		this.applyControlAssignee(control);
	},
  },
  computed:{
	...mapGetters({ userInfo: 'userInfo',tenantsInfo:'tenantsInfo' }),
    today() {
		const today = new Date();
		const year = today.getFullYear();
		const month = String(today.getMonth() + 1).padStart(2, '0'); 
		const day = String(today.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	},	
	isAddDisabled() :boolean{
		try {
			// if (this.userInfo.organisationType !== 10701) {
			// 	return false; // or true if you want to disable for others
			// }
			return !this.hasPermission(this.userInfo, 10007, 10117, 10301);
		} catch (e) {
			console.error("Permission check failed:", e);
			return true; // safest fallback = disable the button
		}
	}
  },
  
  async created(){
	this.dataLoading = true;	 
	// await this.getAllBusinessProcesses();
	// await this.getAllProjects();
	// await this.getAllActiveUsers();
	// await this.getAllActiveControls();
	// await this.getAllTeams();
	// await this.getAllSystems();
	await this.getAllTasks();
	// await this.getActiveTemplates(20501);
	// await this.getControlLevelInfo();
	this.dataLoading=false;
	
  },

  async mounted() {	
	this.dataLoading=true
	emitter.off('clickedOnRowData')
	emitter.on('clickedOnRowData',async (dataObj:any)=>{
		this.goToTemplateTaskEdit(dataObj.id)
	})

    document.addEventListener('click', this.handleClickOutside);
	
	emitter.off('clickedOnSubTaskRowData')
	emitter.on('clickedOnSubTaskRowData',async (dataObj:any)=>{
		this.goToSubTaskEdit(dataObj.id);
	})
			
	emitter.off('activiteToolTip');
	emitter.on('activiteToolTip', (data: any) => {
		this.toolTipActive = true;
		this.toolTipText = data.tipText
	});

	emitter.off('deActiviteToolTip');
	emitter.on('deActiviteToolTip', (data: any) => {
		this.toolTipActive = false;
		this.toolTipText = ''
	});
	this.dataLoading=false
  },
});
</script>